<template>
  <button
    class="user-avatar"
    :class="{ '-is-admin': isAdmin }"
    type="button"
    :title="
      title ?? user?.name
        ? `${user?.name}`
        : $t('labels.pending')
    "
  >
    <span v-if="user?.firstname == null">
      {{ nameInitials.join("") }}
    </span>
    <span v-else-if="user?.lastname == null">{{ user.firstname[0] }}</span>
    <span v-else>{{ user.firstname[0] }}{{ user.lastname[0] }}</span>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const {
  user,
  isAdmin = false,
  title = null
} = defineProps<{
  user: {
    firstname?: string | null;
    lastname?: string | null;
    name?: string | null;
  } | null;
  isAdmin?: boolean;
  title?: string;
}>();

const name = computed(() => {
  if (!user) return "?";
  if (user.name) return user.name;
  if (!user.firstname) return user.lastname ?? "?";
  return `${user.firstname} ${user.lastname}`;
});

const nameParts = computed(() => {
  if (name.value == null) return ["?"];
  return name.value.split(" ");
});

const nameInitials = computed(() => {
  if (!user) return ["?"];
  if (user.firstname && user.lastname) return [user.firstname[0], user.lastname[0]];
  return nameParts.value.map((part) => part[0]);
});
</script>

<style lang="scss">
.user-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-text-lighter);
  border-radius: 5000em;
  padding: 0.25em;
  aspect-ratio: 1 / 1;
  width: 2.5em;
  //height: 2.5em;
  text-align: center;
  font-weight: 600;
  position: relative;

  border: 2px solid var(--color-action-contrast);
  cursor: default;
  //box-shadow: 0 0 3px var(--color-shadow-1);

  &.-is-admin {
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 1px;
      right: 1px;
      height: 0.5em;
      width: 0.5em;
      background-color: var(--color-action);
      border-radius: 50%;
    }
  }
}
</style>
